import React, { useState } from 'react';
import {
 DropdownMenu,
 DropdownMenuContent,
 DropdownMenuItem,
 DropdownMenuTrigger,
} from '../../../ui/dropdown-menu';
import {
 Dialog,
 DialogContent,
 DialogHeader,
 DialogTitle,
 DialogDescription,
 DialogFooter,
} from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { IconFileExport, IconCircleDashed, IconCheck, IconArchive, IconUsers, IconEdit } from '@tabler/icons-react';
import { useWorkflow } from '../../../../contexts/WorkflowContext';

const SettingsMenu = ({ anchorEl, open, onClose, campaign, onEditClick }) => {
 const { pauseCampaign, finishCampaign, archiveCampaign, exportCampaign, transitionCampaign } = useWorkflow();
 const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);

 const handleExport = async () => {
 onClose();
 try {
 await exportCampaign(campaign._id);
 } catch (error) {
 console.error('Export failed:', error);
 }
 };

 const handlePause = async () => {
 onClose();
 try {
 await pauseCampaign(campaign._id);
 } catch (error) {
 console.error('Pause failed:', error);
 }
 };

 const handleFinish = async () => {
 onClose();
 try {
 await finishCampaign(campaign._id);
 } catch (error) {
 console.error('Finish failed:', error);
 }
 };

 const handleArchiveClick = () => {
 onClose();
 setArchiveDialogOpen(true);
 };

 const handleArchiveConfirm = async () => {
 setArchiveDialogOpen(false);
 try {
 await archiveCampaign(campaign._id);
 } catch (error) {
 console.error('Archive failed:', error);
 }
 };

 const handleArchiveCancel = () => {
 setArchiveDialogOpen(false);
 };

 const handleMoveToRecruitment = async () => {
 onClose();
 try {
 await transitionCampaign(campaign._id, 'recruitment', 'Moved to recruitment from waiting');
 } catch (error) {
 console.error('Move to recruitment failed:', error);
 }
 };

 const handleEditMenuClick = () => {
 console.log('[SettingsMenu] Edit Campaign clicked', { campaign });
 onClose();
 if (onEditClick) {
 onEditClick(campaign);
 }
 };

 // Check if campaign is in waiting_to_start stage
 const isWaiting = campaign?.workflowStage === 'waiting_to_start';

 return (
 <>
 <DropdownMenu open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
 <DropdownMenuTrigger asChild>
 <span ref={(el) => { if (anchorEl && el) el.style.position = 'fixed'; }} className="sr-only" />
 </DropdownMenuTrigger>
 <DropdownMenuContent
 align="end"
 className="min-w-[200px]"
 style={anchorEl ? {
 position: 'fixed',
 top: anchorEl.getBoundingClientRect().bottom + 4,
 left: anchorEl.getBoundingClientRect().right,
 transform: 'translateX(-100%)',
 } : undefined}
 >
 <DropdownMenuItem onClick={handleEditMenuClick} className="gap-2 px-3 py-2.5 cursor-pointer">
 <IconEdit size={18} className="text-text-secondary" />
 <span>Edit Campaign</span>
 </DropdownMenuItem>

 <DropdownMenuItem onClick={handleExport} className="gap-2 px-3 py-2.5 cursor-pointer">
 <IconFileExport size={18} className="text-text-secondary" />
 <span>Export CSV</span>
 </DropdownMenuItem>

 {isWaiting ? (
 <DropdownMenuItem onClick={handleMoveToRecruitment} className="gap-2 px-3 py-2.5 cursor-pointer">
 <IconUsers size={18} className="text-text-secondary" />
 <span>Start Recruitment</span>
 </DropdownMenuItem>
 ) : (
 <DropdownMenuItem onClick={handlePause} className="gap-2 px-3 py-2.5 cursor-pointer">
 <IconCircleDashed size={18} className="text-text-secondary" />
 <span>Move to Waiting</span>
 </DropdownMenuItem>
 )}

 <DropdownMenuItem onClick={handleFinish} className="gap-2 px-3 py-2.5 cursor-pointer">
 <IconCheck size={18} className="text-text-secondary" />
 <span>Mark as Finished</span>
 </DropdownMenuItem>

 <DropdownMenuItem onClick={handleArchiveClick} className="gap-2 px-3 py-2.5 cursor-pointer text-error focus:text-error">
 <IconArchive size={18} />
 <span>Archive Campaign</span>
 </DropdownMenuItem>
 </DropdownMenuContent>
 </DropdownMenu>

 {/* Archive Confirmation Dialog */}
 <Dialog open={archiveDialogOpen} onOpenChange={(isOpen) => { if (!isOpen) handleArchiveCancel(); }}>
 <DialogContent>
 <DialogHeader>
 <DialogTitle>Archive Campaign?</DialogTitle>
 <DialogDescription>
 Archive &quot;{campaign?.name}&quot;? It will be removed from active campaign views without deleting its data.
 </DialogDescription>
 </DialogHeader>
 <DialogFooter className="gap-2">
 <Button variant="outline" onClick={handleArchiveCancel}>
 Cancel
 </Button>
 <Button variant="destructive" onClick={handleArchiveConfirm}>
 Archive
 </Button>
 </DialogFooter>
 </DialogContent>
 </Dialog>
 </>
 );
};

export default SettingsMenu;
